// src/config/profilesConfig.js

export const PROFILES = {
  ROOT: 'Root',
  ADMIN: 'Admin',
  DOCENTE: 'Docente',
  ESTUDIANTE: 'Estudiante',
  SOPORTE1: 'Soporte1',
  SOPORTE2: 'Soporte2'
};

// Tipos de usuario
export const TIPO_USUARIO = {
  SISTEMA: 'SISTEMA',
  COLEGIO: 'COLEGIO'
};

// Configuración para Root del SISTEMA (crea y administra colegios)
const rootSistemaConfig = {
  modules: [
    { id: 'dashboard', path: '/dashboard', icon: '📊', label: 'Dashboard', component: 'DashboardRoot' },
    { id: 'config-colegio', path: '/colegios', icon: '🏫', label: 'Colegios', component: 'ConfigColegio' },
    { id: 'perfiles', path: '/perfiles', icon: '🔐', label: 'Perfiles', component: 'Perfiles' },
    { id: 'correo', path: '/correo', icon: '📧', label: 'Correo', component: 'ConfiguracionCorreo' },
    { id: 'usuarios', path: '/usuarios', icon: '👥', label: 'Usuarios', component: 'Usuarios' },
    { id: 'financiero-plataforma', path: '/financiero-plataforma', icon: '💵', label: 'Financiero', component: 'FinancieroPlataforma' },
    { id: 'soporte-dashboard', path: '/soporte', icon: '🛟', label: 'Soporte', component: 'DashboardSoporte' },
    { id: 'encuestas', path: '/encuestas', icon: '📋', label: 'Encuestas', component: 'EncuestasPlataforma' },
    { id: 'propuesta', path: '/propuesta', icon: '📄', label: 'Propuesta', component: 'PropuestaComercial' },
    { id: 'testing', path: '/testing', icon: '🧪', label: 'Testing', component: 'TestingRoot' },
    { id: 'docs', path: '/docs', icon: '📖', label: 'Docs', component: 'DocsRoot' },
  ],
  defaultPath: '/dashboard'
};

// Configuración para Soporte Nivel 1
const soporte1Config = {
  modules: [
    { id: 'dashboard', path: '/dashboard', icon: '📊', label: 'Dashboard', component: 'DashboardSoporte' },
    { id: 'bandeja', path: '/bandeja', icon: '📥', label: 'Bandeja', component: 'BandejaSoporte1' },
  ],
  defaultPath: '/dashboard'
};

// Configuración para Soporte Nivel 2
const soporte2Config = {
  modules: [
    { id: 'dashboard', path: '/dashboard', icon: '📊', label: 'Dashboard', component: 'DashboardSoporte' },
    { id: 'bandeja', path: '/bandeja', icon: '📥', label: 'Bandeja', component: 'BandejaSoporte2' },
  ],
  defaultPath: '/dashboard'
};

// Configuración para Root del COLEGIO (personaliza su colegio)
const rootColegioConfig = {
  modules: [
    { id: 'usuarios', path: '/usuarios', icon: '👥', label: 'Usuarios', component: 'UsuariosColegio' },
    { id: 'perfiles', path: '/perfiles', icon: '🔐', label: 'Perfiles', component: 'PerfilesColegio' },
    { id: 'configuracion', path: '/configuracion', icon: '⚙️', label: 'Configuración', component: 'ConfiguracionColegio' },
    { id: 'admin-datos', path: '/admin-datos', icon: '♻️', label: 'Admin Datos', component: 'AdminDatos' },
  ],
  defaultPath: '/usuarios'
};

export const profilesConfig = {
  [PROFILES.ROOT]: rootSistemaConfig, // Por defecto, Root del sistema
  [PROFILES.SOPORTE1]: soporte1Config,
  [PROFILES.SOPORTE2]: soporte2Config,

  [PROFILES.ADMIN]: {
    modules: [
      { id: 'dashboard', path: '/dashboard', icon: '📊', label: 'Dashboard', component: 'DashboardAdmin' },
      {
        id: 'administracion',
        path: '/administracion',
        icon: '🏫',
        label: 'Administración',
        component: 'Administracion',
        subItems: [
          { id: 'areas', path: '/administracion/areas', icon: '📂', label: 'Áreas', component: 'AreasAdmin' },
          { id: 'materias', path: '/administracion/materias', icon: '📖', label: 'Materias', component: 'MateriasAdmin' },
          { id: 'intensidad-horaria', path: '/administracion/intensidad-horaria', icon: '🕐', label: 'Intensidad Horaria', component: 'IntensidadHoraria' },
          { id: 'horarios', path: '/administracion/horarios', icon: '📅', label: 'Horarios', component: 'HorariosAdmin' },
          { id: 'cursos-admin', path: '/administracion/cursos', icon: '🎓', label: 'Cursos', component: 'CursosAdmin' },
          { id: 'carga-academica', path: '/administracion/carga-academica', icon: '📋', label: 'Carga Académica', component: 'CargaAcademica' },
          { id: 'direccion-curso', path: '/administracion/direccion-curso', icon: '📋', label: 'Dirección de Curso', component: 'DireccionCursoAdmin' },
        ]
      },
      {
        id: 'configuracion',
        path: '/configuracion',
        icon: '⚙️',
        label: 'Configuración',
        component: 'Configuracion',
        subItems: [
          { id: 'contenidos', path: '/configuracion/contenidos', icon: '📊', label: 'Contenidos', component: 'ContenidosAdmin' },
          { id: 'escalas-notas', path: '/configuracion/escalas-notas', icon: '🎯', label: 'Escalas de Notas', component: 'EscalasNotasAdmin' },
          { id: 'nota-aprobacion', path: '/configuracion/nota-aprobacion', icon: '✓', label: 'Nota de Aprobación', component: 'NotaAprobacionAdmin' },
          { id: 'periodos', path: '/configuracion/periodos', icon: '📅', label: 'Períodos', component: 'PeriodosAdmin' },
          { id: 'config-notas', path: '/configuracion/notas', icon: '📝', label: 'Notas', component: 'ConfigNotasAdmin' },
          { id: 'config-aula-virtual', path: '/configuracion/aula-virtual', icon: '🎓', label: 'Aula Virtual', component: 'ConfigAulaVirtualAdmin' },
          { id: 'config-financiero', path: '/configuracion/financiero', icon: '💰', label: 'Financiero', component: 'ConfigFinancieroAdmin' },
          { id: 'modulos-perfil', path: '/configuracion/modulos-perfil', icon: '📱', label: 'Módulos por Perfil', component: 'ModulosPerfilAdmin' },
          { id: 'bloquear-notas', path: '/configuracion/bloquear-notas', icon: '🔒', label: 'Bloquear Notas', component: 'BloquearNotasAdmin' },
          { id: 'caracterizacion-config', path: '/configuracion/caracterizacion', icon: '📝', label: 'Caracterización', component: 'CaracterizacionAdmin' },
          { id: 'caracterizacion-v2-config', path: '/configuracion/caracterizacion-v2', icon: '👁️', label: 'Caracterización V2', component: 'CaracterizacionV2Admin' },
        ]
      },
      { id: 'usuarios', path: '/usuarios', icon: '👥', label: 'Usuarios', component: 'UsuariosColegio' },
      { id: 'prematriculas', path: '/prematriculas', icon: '📝', label: 'Prematrículas', component: 'PrematriculasAdmin' },
      { id: 'financiero', path: '/financiero', icon: '💵', label: 'Financiero', component: 'FinancieroAdmin' },
      { id: 'circulares', path: '/circulares', icon: '📢', label: 'Circulares', component: 'CircularesAdmin' },
      { id: 'elecciones', path: '/elecciones', icon: '🗳️', label: 'Elecciones', component: 'EleccionesAdmin' },
      { id: 'inasistencias', path: '/inasistencias', icon: '📋', label: 'Inasistencias', component: 'InasistenciasAdmin' },
      {
        id: 'boletines',
        path: '/boletines',
        icon: '📋',
        label: 'Boletines',
        component: 'Boletines',
        subItems: [
          { id: 'generar-boletines', path: '/boletines/generar', icon: '📄', label: 'Generar', component: 'GenerarBoletines' },
          { id: 'fotos-estudiantes', path: '/boletines/fotos', icon: '📷', label: 'Fotos', component: 'FotosEstudiantesAdmin' },
          { id: 'config-boletines', path: '/boletines/configuracion', icon: '⚙️', label: 'Configuración', component: 'ConfigBoletines' },
        ]
      },
      { id: 'carnets', path: '/carnets', icon: '🪪', label: 'Carnets', component: 'CarnetsAdmin' },
      { id: 'certificados', path: '/certificados', icon: '📜', label: 'Certificados', component: 'GenerarCertificados' },
      {
        id: 'reportes',
        path: '/reportes',
        icon: '📊',
        label: 'Reportes',
        component: 'Reportes',
        subItems: [
          { id: 'reporte-global', path: '/reportes/global', icon: '🏛️', label: 'Reporte Global', component: 'ReporteGlobalAdmin' },
          { id: 'reporte-notas', path: '/reportes/notas', icon: '📝', label: 'Reporte de Notas', component: 'ReporteNotasDocente' },
          { id: 'sabana-notas', path: '/reportes/sabana', icon: '📋', label: 'Sábana de Notas', component: 'SabanaNotasDocente' },
          { id: 'promedios-acumulados', path: '/reportes/promedios', icon: '📈', label: 'Promedios Acumulados', component: 'PromediosAcumuladosDocente' },
          { id: 'reprobados', path: '/reportes/reprobados', icon: '⚠️', label: 'Reprobados', component: 'ReprobadosDocente' },
        ]
      },
      { id: 'observaciones', path: '/observaciones', icon: '✍️', label: 'Observaciones', component: 'ObservacionesDocente' },
      { id: 'agendamientos', path: '/agendamientos', icon: '👥', label: 'Agendamientos', component: 'AgendamientosDocente' },
      { id: 'biblioteca', path: '/biblioteca', icon: '📖', label: 'Biblioteca', component: 'BibliotecaDocente' },
      { id: 'encuestas', path: '/encuestas', icon: '📋', label: 'Encuestas', component: 'EncuestasAdmin' },
      { id: 'exportar-datos', path: '/exportar-datos', icon: '📥', label: 'Exportar Datos', component: 'ExportarDatosAdmin' },
      { id: 'soporte', path: '/soporte', icon: '🛟', label: 'Soporte', component: 'SoporteAdmin' },
      { id: 'seguimiento', path: '/seguimiento', icon: '🔍', label: 'Seguimiento', component: 'SeguimientoAdmin' },
      { id: 'mallas', path: '/mallas', icon: '🧩', label: 'Mallas Curriculares', component: 'MallasList' },
      { id: 'cuadro-honor', path: '/cuadro-honor', icon: '🏅', label: 'Cuadro de Honor', component: 'CuadroHonor' },
    ],
    defaultPath: '/dashboard'
  },

  [PROFILES.DOCENTE]: {
    modules: [
      { id: 'dashboard', path: '/dashboard', icon: '📊', label: 'Dashboard', component: 'DashboardDocente' },
      { id: 'notas', path: '/notas', icon: '📝', label: 'Notas', component: 'NotasDocente' },
      { id: 'mallas', path: '/mallas', icon: '🧩', label: 'Mallas Curriculares', component: 'MallasList' },
      { id: 'aula-virtual', path: '/aula-virtual', icon: '🎓', label: 'Aula Virtual', component: 'AulaVirtualDocente' },
      { id: 'inasistencias', path: '/inasistencias', icon: '📋', label: 'Inasistencias', component: 'InasistenciasDocente' },
      { id: 'agenda', path: '/agenda', icon: '📆', label: 'Agenda', component: 'AgendaDocente' },
      { id: 'biblioteca', path: '/biblioteca', icon: '📖', label: 'Biblioteca', component: 'BibliotecaDocente' },
      { id: 'observaciones', path: '/observaciones', icon: '✍️', label: 'Observaciones', component: 'ObservacionesDocente' },
      { id: 'agendamientos', path: '/agendamientos', icon: '👥', label: 'Agendamientos', component: 'AgendamientosDocente' },
      { id: 'soporte', path: '/soporte', icon: '🛟', label: 'Soporte', component: 'SoporteDocente' },
      { id: 'nivelaciones', path: '/nivelaciones', icon: '📈', label: 'Nivelaciones', component: 'NivelacionesDocente' },
      {
        id: 'boletines',
        path: '/boletines',
        icon: '📋',
        label: 'Boletines',
        component: 'Boletines',
        subItems: [
          { id: 'vista-previa-boletines', path: '/boletines/vista-previa', icon: '👁️', label: 'Vista Previa', component: 'VistaPreviaBoletinesDocente' },
          { id: 'desempenos', path: '/boletines/desempenos', icon: '📄', label: 'Desempeños', component: 'DesempenosDocente' },
          { id: 'observaciones-boletin', path: '/boletines/observaciones', icon: '✏️', label: 'Observaciones', component: 'ObservacionesBoletinDocente' },
        ]
      },
      {
        id: 'reportes',
        path: '/reportes',
        icon: '📊',
        label: 'Reportes',
        component: 'Reportes',
        subItems: [
          { id: 'reporte-notas', path: '/reportes/notas', icon: '📝', label: 'Reporte de Notas', component: 'ReporteNotasDocente' },
          { id: 'sabana-notas', path: '/reportes/sabana', icon: '📋', label: 'Sábana de Notas', component: 'SabanaNotasDocente' },
          { id: 'promedios-acumulados', path: '/reportes/promedios', icon: '📈', label: 'Promedios Acumulados', component: 'PromediosAcumuladosDocente' },
          { id: 'reprobados', path: '/reportes/reprobados', icon: '⚠️', label: 'Reprobados', component: 'ReprobadosDocente' },
        ]
      },
      { id: 'elecciones', path: '/elecciones', icon: '🗳️', label: 'Elecciones', component: 'EleccionesDocente' },
      { id: 'circulares', path: '/circulares', icon: '📢', label: 'Circulares', component: 'CircularesDocente' },
      { id: 'encuestas', path: '/encuestas', icon: '📋', label: 'Encuestas', component: 'EncuestasDocente' },
      { id: 'salas-virtuales', path: '/salas-virtuales', icon: '💻', label: 'Salas Virtuales', component: 'SalasVirtualesDocente' },
      {
        id: 'caracterizacion',
        path: '/caracterizacion',
        icon: '📝',
        label: 'Caracterización',
        component: 'Caracterizacion',
        subItems: [
          { id: 'caracterizacion-inicial', path: '/caracterizacion/inicial', icon: '📋', label: 'Inicial', component: 'CaracterizacionDocente' },
          { id: 'caracterizacion-v2', path: '/caracterizacion/v2', icon: '👁️', label: 'V2 (Observador)', component: 'CaracterizacionV2Docente' },
        ]
      },
    ],
    defaultPath: '/dashboard'
  },

  [PROFILES.ESTUDIANTE]: {
    modules: [
      { id: 'dashboard', path: '/dashboard', icon: '📊', label: 'Dashboard', component: 'DashboardEstudiante' },
      { id: 'notas', path: '/notas', icon: '📝', label: 'Notas', component: 'NotasEstudiante' },
      { id: 'fallas', path: '/fallas', icon: '📋', label: 'Fallas', component: 'FallasEstudiante' },
      { id: 'agenda', path: '/agenda', icon: '📆', label: 'Agenda', component: 'Agenda' },
      { id: 'horario', path: '/horario', icon: '🕐', label: 'Horario', component: 'Horario' },
      { id: 'biblioteca', path: '/biblioteca', icon: '📖', label: 'Biblioteca', component: 'BibliotecaEstudiante' },
      { id: 'aula-virtual', path: '/aula-virtual', icon: '🎓', label: 'Aula Virtual', component: 'AulaVirtualEstudiante' },
      { id: 'observaciones', path: '/observaciones', icon: '✍️', label: 'Observaciones', component: 'Observaciones' },
      { id: 'circulares', path: '/circulares', icon: '📢', label: 'Circulares', component: 'CircularesEstudiante' },
      { id: 'financiero', path: '/financiero', icon: '💰', label: 'Financiero', component: 'FinancieroEstudiante' },
      { id: 'agendamientos', path: '/agendamientos', icon: '👥', label: 'Agendamientos', component: 'AgendamientosEstudiante' },
      { id: 'elecciones', path: '/elecciones', icon: '🗳️', label: 'Elecciones', component: 'EleccionesEstudiante' },
      { id: 'encuestas', path: '/encuestas', icon: '📋', label: 'Encuestas', component: 'EncuestasEstudiante' },
      { id: 'boletines', path: '/boletines', icon: '📋', label: 'Boletines', component: 'BoletinesEstudiante' },
      // Visible solo si el colegio activa la renovación (lo calcula /modulos-perfil desde la config)
      { id: 'prematricula', path: '/prematricula', icon: '📝', label: 'Prematrícula', component: 'PrematriculaEstudiante' },
    ],
    defaultPath: '/dashboard'
  }
};

/**
 * Obtiene los módulos para un rol y tipo de usuario
 * @param {string} role - Rol del usuario (Root, Admin, Docente, Estudiante)
 * @param {string} tipoUsuario - Tipo de usuario (SISTEMA o COLEGIO)
 */
export const getProfileModules = (role, tipoUsuario = TIPO_USUARIO.SISTEMA) => {
  // Caso especial: Root de COLEGIO tiene módulos diferentes
  if (role === PROFILES.ROOT && tipoUsuario === TIPO_USUARIO.COLEGIO) {
    return rootColegioConfig.modules;
  }

  const profile = profilesConfig[role];
  return profile ? profile.modules : profilesConfig[PROFILES.ESTUDIANTE].modules;
};

/**
 * Obtiene la ruta por defecto para un rol y tipo de usuario
 * @param {string} role - Rol del usuario
 * @param {string} tipoUsuario - Tipo de usuario (SISTEMA o COLEGIO)
 */
export const getDefaultPath = (role, tipoUsuario = TIPO_USUARIO.SISTEMA) => {
  // Caso especial: Root de COLEGIO
  if (role === PROFILES.ROOT && tipoUsuario === TIPO_USUARIO.COLEGIO) {
    return rootColegioConfig.defaultPath;
  }

  const profile = profilesConfig[role];
  return profile ? profile.defaultPath : '/home';
};

/**
 * Obtiene el módulo actual basado en la ruta
 * @param {string} pathname - Ruta actual
 * @param {string} role - Rol del usuario
 * @param {string} tipoUsuario - Tipo de usuario
 */
export const getModuleByPath = (pathname, role, tipoUsuario = TIPO_USUARIO.SISTEMA) => {
  const modules = getProfileModules(role, tipoUsuario);
  return modules.find(m => m.path === pathname) || modules[0];
};
